export default __webpack_public_path__ + "static/media/black.e1de1bdd.png";